"use client";
import { differenceInMonths } from "date-fns/differenceInMonths";
import { startOfMonth } from "date-fns/startOfMonth";
import { useEffect, useMemo, useRef } from "react";
import { getDefaultMonth } from "../helpers/helpers.js";
const SCROLL_TO_SELECTED_DELAY_MS = 250;
const SCROLL_TO_SELECTED_MAX_RETRIES = 8;
const SCROLL_TO_SELECTED_RETRY_MS = 80;
function useScrollToSelectedMonth({ containerRef, scrollToSelectedMonthOnOpen, isMobile, numberOfMonths, startMonth, mode, selected, defaultMonth }) {
    const hasScrolledRef = useRef(false);
    const targetMonthDate = useMemo(()=>defaultMonth ?? getDefaultMonth({
            mode,
            selected
        }), [
        defaultMonth,
        mode,
        selected
    ]);
    useEffect(()=>{
        if (!scrollToSelectedMonthOnOpen || !isMobile) {
            if (!scrollToSelectedMonthOnOpen) hasScrolledRef.current = false;
            return;
        }
        if (hasScrolledRef.current) return;
        const firstMonth = startMonth ?? startOfMonth(new Date());
        const targetMonth = targetMonthDate ? startOfMonth(targetMonthDate) : firstMonth;
        const targetIndex = differenceInMonths(targetMonth, firstMonth);
        if (targetIndex < 0 || targetIndex >= numberOfMonths) return;
        let retries = 0;
        let timeoutId;
        const tryScroll = ()=>{
            const container = containerRef.current;
            if (!container) return;
            const grids = container.querySelectorAll('[role="grid"]');
            if (0 === grids.length && retries < SCROLL_TO_SELECTED_MAX_RETRIES) {
                retries += 1;
                timeoutId = setTimeout(tryScroll, SCROLL_TO_SELECTED_RETRY_MS);
                return;
            }
            const grid = grids[targetIndex];
            if (grid) {
                hasScrolledRef.current = true;
                grid.scrollIntoView?.({
                    block: 'start',
                    behavior: 'auto'
                });
            }
        };
        timeoutId = setTimeout(tryScroll, SCROLL_TO_SELECTED_DELAY_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        scrollToSelectedMonthOnOpen,
        isMobile,
        numberOfMonths,
        startMonth,
        targetMonthDate,
        containerRef
    ]);
}
export { useScrollToSelectedMonth };
